// extracted by mini-css-extract-plugin
export default {"loadingModal":"LoadingModal_loadingModal__SLdm7","loadingModal__bear":"LoadingModal_loadingModal__bear__qeoH6","loadingModal__title":"LoadingModal_loadingModal__title__PfIQN"};